/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Modal } from '@material-ui/core';
import { BreakPointSm } from '../Helpers/Helper';

const styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        position: 'relative',
    },
    modalContainer: {
        backgroundColor: theme.palette.white,
        width: '340px',
        height: '230px',
        position: 'relative',
        overflow: 'auto',
    },
    modalXs: {
        minHeight: '250px',
        maxHeight: '90vh',
        width: '270px',
        height: 'auto',
    },
    modalSm: {
        minWidth: '280px',
        maxHeight: '250px',
        width: '26%',
        height: '80vh',
    },
    modalMd: {
        width: '55%',
        height: '80vh',
        [theme.breakpoints.down(BreakPointSm)]: {
            width: '90%',
        },
    },
    modalLg: {
        width: '90%',
        height: 'calc(100% - 100px)',
    },
    headingText: {
        fontSize: '1em',
        lineHeight: '48px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0',
        padding: '0 20px 0 4px',
        fontWeight: '700',
        boxShadow: `0 4px 2px -2px ${theme.palette.common?.grey}`,
        textAlign: 'center',
        position: 'sticky',
        top: '0',
        background: theme.palette.cms?.white || '#ffffff',
        zIndex: 2,
    },
    alignTextLeft: {
        textAlign: 'left',
    },
    description: {
        background: theme.palette.white,
        overflowY: 'auto',
        padding: '5px 10px 0',
        '& a': {
            color: theme.palette.cta1,
            textDecoration: 'none',
        },
        '& h2': {
            fontSize: '0.9em',
            color: theme.palette.cta1,
            margin: '20px 0 7px',
        },
        '& img': {
            width: 'auto',
        },
        '& p': {
            marginTop: '0',
        },
    },
    right: {
        right: '20px',
        position: 'absolute',
        fontSize: '20px',
        fontWeight: '500',
        cursor: 'pointer',
    },

});

const ModalWrapper = (props) => {
    const {
        modalTitle, modalContent, classes, onCloseModal,
        isOpen, btnClose, alignItem, modalSize, customStyle,
        headerCustomStyle, contentCustomStyle,
    } = props;
    let classTitle = classes.headingText;
    if (alignItem === 'left') {
        classTitle += ` ${classes.alignTextLeft}`;
    }
    if (headerCustomStyle) {
        classTitle += ` ${headerCustomStyle}`;
    }
    let classContent = classes.description;
    if (contentCustomStyle) {
        classContent += ` ${contentCustomStyle}`;
    }
    const modalContainerSize = () => {
        switch (modalSize) {
            case 'xs':
                return `${classes.modalContainer} ${classes.modalXs}`;
            case 'sm':
                return `${classes.modalContainer} ${classes.modalSm}`;
            case 'md':
                return `${classes.modalContainer} ${classes.modalMd}`;
            case 'lg':
                return `${classes.modalContainer} ${classes.modalLg}`;
            case 'custom':
                return `${classes.modalContainer} ${customStyle}`;
            default:
                return classes.modalContainer;
        }
    };
    return (
        <div>
            <Modal
                id="modalWrapper"
                open={isOpen}
                onClose={onCloseModal}
                className={classes.modal}
            >
                <div className={modalContainerSize()}>
                    <h1 id="h1-title" data-testid="h1-title" className={classTitle}>
                        {modalTitle}
                        {btnClose && (
                            <span
                                id="modalClose"
                                data-testid="modalClose"
                                className={classes.right}
                                onClick={() => onCloseModal()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        onCloseModal();
                                    }
                                }}
                                role="button"
                                tabIndex={0}
                                aria-label="Close modal"
                            >
                                X
                            </span>
                        )}
                    </h1>
                    <div id="modal-content" data-testid="modal-content" className={classContent}>
                        {modalContent}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

ModalWrapper.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    modalTitle: PropTypes.string.isRequired,
    modalContent: PropTypes.element.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    btnClose: PropTypes.bool,
    alignItem: PropTypes.string,
    modalSize: PropTypes.string,
    customStyle: PropTypes.string,
    headerCustomStyle: PropTypes.string,
    contentCustomStyle: PropTypes.string,
};

ModalWrapper.defaultProps = {
    btnClose: true,
    alignItem: 'center',
    modalSize: 'small',
    customStyle: '',
    headerCustomStyle: '',
    contentCustomStyle: '',
};

export default withStyles(styles)(ModalWrapper);
